/** Sahari Cargo WhatsApp line (0534700264, as given by the owner). */
export const WHATSAPP_NUMBER = '966534700264';
export const WHATSAPP_DISPLAY = '+966 53 470 0264';

const DEFAULT_MESSAGE = "Hi Sahari Cargo, I'd like to send a shipment from Saudi Arabia.";

/** wa.me click-to-chat link: opens the WhatsApp app (or WhatsApp Web) with
    a ready-typed first message, so the customer never types our number. */
export const whatsappLink = (message: string = DEFAULT_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

/** Branch phone lines, in the order shown on the Home page. */
export type Branch = {
  city: string;
  phone: string;
};

export const BRANCHES: Branch[] = [
  { city: 'JEDDAH', phone: '+966 505216943' },
  { city: 'MAKKAH', phone: '+966 595966673' },
  { city: 'MADINAH', phone: '+966 536122922' },
  { city: 'MUHAYIL', phone: '+966 539217340' },
  { city: 'ABHA', phone: '+966 505216943' },
  { city: 'KHAMIS MUSHAIT', phone: '+966 593897382' },
  { city: 'TAIF', phone: '+966 537814588' },
  { city: 'YANBU', phone: '+966 530192322' },
  { city: 'RABIGH', phone: '+966 595966697' },
  { city: 'JIZAN', phone: '+966 558791223' },
  { city: 'RIYADH', phone: '+966 505216943' },
  { city: 'DUBA', phone: '+966 563096436' },
];

/** tel: link for a displayed phone number ("+966 0530712834" → "+966530712834"). */
export const telHref = (phone: string) => {
  const digits = phone.replace(/\D/g, '').replace(/^9660/, '966');
  return `tel:+${digits}`;
};

/** "JEDDAH" / "KHAMIS MUSHAIT" → "Jeddah" / "Khamis Mushait". */
export const cityLabel = (city: string) =>
  city.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

/** Footer contact details. */
export const CONTACT_EMAIL = 'saharicourier@gmail.com';
export const MAIN_PHONE = '+966 505216943';

/**
 * Social profiles shown in the footer. Leave `url` empty until the real
 * profile link is known — the icon still shows but isn't a dead link.
 */
export const SOCIAL_LINKS: Array<{ key: string; label: string; url: string }> = [
  { key: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/saharicargo' },
  { key: 'x', label: 'X', url: '' },
  { key: 'linkedin', label: 'LinkedIn', url: '' },
  { key: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/share/1BxcjAkuvy/' },
  { key: 'tiktok', label: 'TikTok', url: '' },
  { key: 'youtube', label: 'YouTube', url: '' },
  { key: 'snapchat', label: 'Snapchat', url: '' },
];
